import { type NodeProps, Position } from '@xyflow/react';
import EditIcon from '@mui/icons-material/Edit';

import type { NodeItem, ParentNode, DataItems, RetryInterval } from '@models/flows';
import { Connector, renderRetryInterval } from '@utils/flows';
import { initialSuccessNodeData } from '@features/chargerFlows/validation/validation-helpers';

import { useNodeError } from '@hooks/useNodeError';

import {
  ConnectionPoint,
  DeleteButton,
  ErrorToolTip,
} from '@components/Flows/components/partials/index';

import s from './SuccessNode.module.css';

type SuccessNodeProps = NodeProps & {
  onEdit: (parentNode: ParentNode, childNode: NodeItem) => void;
  onDelete: (nodeId: string) => void;
};

function SuccessNode({ id, type, data, onEdit, onDelete }: SuccessNodeProps) {
  const successNodeData = data as unknown as DataItems;
  const nodeItems = successNodeData?.items || [initialSuccessNodeData];
  const parentNode: ParentNode = {
    id,
    type,
    data: successNodeData,
  };
  const successNodeItem = nodeItems[0];
  const errors = useNodeError(id);

  const handleEdit = () => {
    onEdit(parentNode, successNodeItem);
  };

  const retryInterval: RetryInterval = successNodeItem.retryInterval || {
    days: 0,
    hours: 0,
    minutes: 0,
  };

  return (
    <div className={`${s.container} ${errors ? s.errorBorder : ''}`}>
      <h1 className={s.title}>Success Node</h1>
      <ErrorToolTip isErrorVisible={Boolean(errors)} messages={errors?.messages} />
      <DeleteButton onDelete={() => onDelete(id)} />
      <div className={s.valueBlock}>
        <div className={s.detailsWrapper}>
          <p className={s.detailLine}>
            <span className={s.detailLabel}>Recharge every: </span>
            <span className={s.detailValue}>{renderRetryInterval(retryInterval)}</span>
          </p>
        </div>
        <button type="button" className={s.editButton} onClick={handleEdit}>
          <EditIcon />
        </button>
      </div>
      <ConnectionPoint type={Connector.Target} position={Position.Left} id="incoming" />
    </div>
  );
}

export default SuccessNode;
